(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zbm-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zbm-hero-carousel')) {
    customElements.define('zbm-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-zbm-hero-slide]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('[data-zbm-hero-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-zbm-hero-next]')?.addEventListener('click', () => this.show(this.index + 1));
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.start();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index) {
        this.slides[this.index].classList.remove('is-active');
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides[this.index].classList.add('is-active');
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), 6000);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
